import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d390d23"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d390d23')) {
      api.createRecord('6d390d23', component.options)
    } else {
      api.reload('6d390d23', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d390d23", function () {
      api.rerender('6d390d23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/zbDialog/index.vue"
export default component.exports